import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import InputField from '../../../components/Input-field/input-field.component';
import Button from '../../../components/button/button.component';
import Alert, { ALERT_TYPE } from '../../../components/alert/alert.component';
import { user_resendcode } from '../../../Services/prod/auth.service';
import moment from 'moment';
import 'moment-timezone'; 
import { useAuth } from '../../../Contexts/auth.context';
import { ButtonsContainer, FormContainer, CMContainer } from '../login/login.styles';
import { useLocation, useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { user_confirmation } from '../../../Services/prod/auth.service';
import Heading from '../../../components/heading/heading.component';
moment.tz.setDefault("EST");
const initialValues = {
  code: '',
  email: ''
}

const loginSchema = Yup.object().shape({
  code: Yup.string()
    .required('Verification Code is required'),
});

const Confirm = () => {
  const {currentUser} = useAuth();
  const [countdown, setCountdown] = useState(0);
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const [loading, setLoading] = useState(false);
  const location = useLocation();
  const [email, setEmail] = useState('');
  const [userId, setUserId]= useState('');
  const [userStatus, setUserStatus] = useState('')
  const [statusEmail, setStatusEmail] = useState('')
  const navigate = useNavigate();
 
  useEffect(() => {
    if(location.state) { 
        const {email, userId} = location.state;
        setEmail(email);
        setUserId(userId)
      }
  }, []);

  useEffect(() => {
    let timer;
    if (countdown > 0) {
        timer = setInterval(() => {
            setCountdown(prev => prev - 1);
        }, 1000);
    } else {
        setIsButtonDisabled(false);
    }
    return () => clearInterval(timer);
  }, [countdown]);

  const sendAgain = () => {
    setUserStatus('');
    setIsButtonDisabled(true);
    setLoading(true);
    setCountdown(60); 
    try {
      if (email) {
        user_resendcode(email).then(data => {
          if (data && data.isSuccess === true) {
            setUserStatus("Email sent.");
            setTimeout(() => {
              setUserStatus('');
            }, 5000);
          }
          else {
            setStatusEmail(data.message);
          }
        }).finally(() => {
          setLoading(false);
      });
      }
    } catch (error) {
      console.error(error);
    }
  }

  const handleSubmit = async (values, {setStatus}) => {
    user_confirmation(email, userId, values.code).then(response => {
      if (response) {
        if (response.isSuccess) {
          if(response) {
            navigate('/auth', {state: {verified: true}});
          }
        } else {
          setStatus(response.message);
        }
      } else {
        setStatus('There was an error in the registration process');
      } 

    }).catch(error => {
      setStatus(error);
    }).catch(error => setStatus(error));
  }
    return (
        <div className="App">
          <Heading previusPage={'User Confirmation'} />
          <Formik 
              initialValues={initialValues}
              validationSchema={loginSchema}
              onSubmit={handleSubmit}>
              {({errors, touched, status}) => (
                  <>
                    <CMContainer>
                    {status &&
                      <Alert alertType={ALERT_TYPE.error}>{status}</Alert>
                    }
                    {currentUser &&
                      <Alert alertType={ALERT_TYPE.success}>{currentUser}</Alert>
                    }
                    <Form id='SignUp' autoComplete='false'>
                      <FormContainer>
                        <InputField name='code' className="input_code" id='code' placeholder='Verification Code' isInvalid={errors.code && touched.code} error={errors.code}/>
                        <ButtonsContainer>
                          <Button type='submit' >Submit</Button>
                          <label>Did not receive the code?</label>
                          <Button disabled={isButtonDisabled || loading} type="button" className="resend_code_button" onClick={sendAgain}>Send Again</Button>
                        </ButtonsContainer>
                        {isButtonDisabled && (
                        <p>
                            Try again in {countdown} seconds
                        </p>
                        )}
                      </FormContainer>
                    </Form>
                    {statusEmail && <Alert alertType={ALERT_TYPE.error}>{statusEmail}</Alert>}
                    {userStatus && <Alert alertType={ALERT_TYPE.success} style={{ paddingLeft: '10px' }}>{userStatus}</Alert>}
                    </CMContainer>
                  </>
                )}
              
          </Formik>
        </div>
    );
}

export default Confirm;